export default __webpack_public_path__ + "static/media/getUserRtfs.e64e303e.png";